<template>
	<div class="public-content">
		<div class="breadcrumb">模板页管理</div>
		<div class="add-category">
			<div class="keywords">
				<span style="margin:0;">模板页名称:</span>
				<el-input style="margin:0 10px;" v-model="searchVo.name" placeholder="请输入模板页名称" clearable></el-input>
				<span style="margin:0 2px;">是否关联设计版:</span>
				<el-select v-model="searchVo.isAssociatedePtsTemplate" clearable placeholder="请选择">
					<el-option label="是" :value="true"></el-option>
					<el-option label="否" :value="false"></el-option>
				</el-select>
				<span style="margin:0 2px;" v-show="searchVo.isAssociatedePtsTemplate">尺寸:</span>
				<el-select v-show="searchVo.isAssociatedePtsTemplate" clearable v-model="searchVo.composeSizeId" :filter-method="getSizeList" filterable placeholder="请输入尺寸名称查询">
					<el-option v-for="item in sizeList" :key="item.id" :label="item.sizeName" :value="item.id"></el-option>
				</el-select>
				<span v-show="searchVo.isAssociatedePtsTemplate" style="margin:0 2px;">收选片角色:</span>
				<el-select v-show="searchVo.isAssociatedePtsTemplate" v-model="searchVo.attrId" clearable placeholder="请选择">
					<el-option v-for="item in role" :key="item.attrId" :label="item.attrName" :value="item.attrId"></el-option>
				</el-select>
				<el-button style="margin:0 10px;" round @click="(queryInfo.pageNum = 1), onSubmit()">查询</el-button>
			</div>
			<div>
				<el-button round type="primary" @click="$refs.addModuleDialog.show(false)">新建模板页</el-button>
			</div>
		</div>
		<div class="right-main">
			<el-table :data="tableData" border>
				<el-table-column label="模板页名称" prop="name" width="300px"></el-table-column>
				<el-table-column label="模板页信息" prop="infoStr"></el-table-column>
				<el-table-column label="是否关联设计版" prop="isAssociatedePtsTemplate">
					<template slot-scope="scope"> {{ scope.row.isAssociatedePtsTemplate ? '是' : '否' }} </template>
				</el-table-column>
				<el-table-column label="模板性质" prop="composeSize.attribute">
					<template slot-scope="scope"> {{ scope.row.isAssociatedePtsTemplate ? (scope.row.attribute === 1 ? '半批' : scope.row.attribute === 2 ? '整批' : '') : '' }} </template>
				</el-table-column>
				<el-table-column label="尺寸" prop="composeSize.sizeName">
					<!-- <template slot-scope="scope"> {{ scope.row.isAssociatedePtsTemplate ? $store.state.pms.pageType[scope.row.composeSize.pageTypeCode] : '' }} </template> -->
					<template slot-scope="scope">
						<span class="color-blue" @click="dialogVisible = true, getSizeGroupMsg(scope.row.composeSize.composeSizeId)"> {{ scope.row.composeSize ? scope.row.composeSize.sizeName : '' }} </span>
					</template>
				</el-table-column>
				<el-table-column label="收选片角色" prop="moduleAttribute.attrName">
					<template slot-scope="scope"> {{ scope.row.isAssociatedePtsTemplate ? scope.row.moduleAttribute.attrName : '' }} </template>
				</el-table-column>
				<el-table-column label="页面类型">
					<template slot-scope="scope"> {{ scope.row.isAssociatedePtsTemplate ? $store.state.pms.pageType[scope.row.composeSize.pageTypeCode] : '' }} </template>
				</el-table-column>
				<el-table-column label="操作" width="200px">
					<template slot-scope="scope">
						<span class="color-blue" @click="$refs.checkModule.show(scope.row)"> 查看 <br />
						</span>
						<span class="color-blue" @click="$refs.checkDesign.show(scope.row.moduleId)"> 查看设计版 <br />
						</span>
						<span class="color-blue" @click="$refs.editDesign.show(scope.row.moduleId)"> 编辑设计版 <br />
						</span>
						<span class="color-blue" @click="(deleteItem = scope.row), del(scope.row.moduleId)">删除</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
		<addModuleDialog ref="addModuleDialog" @success="onSubmit"></addModuleDialog>
		<el-dialog :close-on-click-modal="false" title="信息提示" :visible.sync="tipDialog" width="500px">
			<div class="data-list">
				<el-table :data="tipTableData" border>
					<el-table-column label="已关联过的模板名称" prop="templateName"></el-table-column>
				</el-table>
			</div>
			<span style="color:red">请先取消关联，再删除</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="tipDialog = false">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" title="删除确认" :visible.sync="deleteModuleDialog" width="500px"> 是否删除该模板页？ <span slot="footer" class="dialog-footer">
				<el-button @click="deleteModuleDialog = false">取 消</el-button>
				<el-button type="primary" @click="deleteModule()">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" title="尺寸" :visible.sync="dialogVisible" width="70%">
			<div style="width:100%;height:100%;background:red">
				<el-table :data="sizeGroupMsg" border>
					<el-table-column label="尺寸名称" prop="sizeName">
						<template> {{ sizeName }} </template>
					</el-table-column>
					<el-table-column label="页面类型" prop="codeType">
						<template slot-scope="scope"> {{ scope.row.codeType === 'BAR_CODE' ? '条形码' : scope.row.codeType === 'IDENTITY' ? '标识' : scope.row.codeType === 'QR_CODE' ? '双影像二维码' : scope.row.codeType ===
								'LOCKWIRE_BAR_CODE' ? '锁线条码' : scope.row.codeType === 'REMARK' ? '客户备注' : scope.row.codeType === 'VERTICAL_BAR_CODE' ? '上下条码' : scope.row.codeType === 'BLESSING_WALL_QR_CODE' ? '祝福墙二维码' :
									'未定义字段'
						}} </template>
					</el-table-column>
					<el-table-column label="页面名称" prop="pageName"><template> {{ pageName }} </template></el-table-column>
					<el-table-column label="宽高">
						<template slot-scope="scope"> {{ scope.row.width }}*{{ scope.row.height }}mm </template>
					</el-table-column>
					<el-table-column label="出血类型" prop="bleed.bleedName"><template> {{ bleed.bleedName }} </template></el-table-column>
					<el-table-column label="出血" width="220px">
						<template> 上方：{{ bleed.bleedTop }}mm 下方：{{ bleed.bleedBottom }}mm <br> 左侧：{{ bleed.bleedLeft }}mm 右侧：{{ bleed.bleedRight }}mm <br> 内侧：{{ bleed.bleedIn }}mm </template>
					</el-table-column>
					<el-table-column label="码">
						<template slot-scope="scope"> {{ scope.row.barName }} </template>
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
		<checkModule ref="checkModule" />
		<checkDesign ref="checkDesign" />
		<editDesign ref="editDesign" />
	</div>
</template>
<script>
import VPagination from '@/components/Pagination/index'
import { modulePage, moduleDel, adminModuleAttributeList, getTemplateByModuleId } from '@/api/auxx.js'
import { sizeListPaging, sizeDetail } from '@/api/pms.js'
import addModuleDialog from '../components/addModuleDialog.vue'
import checkModule from './checkModule.vue'
import checkDesign from './checkDesign.vue'
import editDesign from './editDesign.vue'
export default {
	components: {
		addModuleDialog,
		VPagination,
		checkModule,
		checkDesign,
		editDesign
	},
	data () {
		return {
			pageName: '',
			sizeName: '',
			sizeGroupMsg: [],
			bleed: {},
			dialogVisible: false,
			deleteModuleDialog: false,
			deleteItem: null,
			queryInfo: {
				total: 0,
				pageNum: 1,
				pageSize: 10
			},
			searchVo: {
				name: '',
				attrId: '',
				isAssociatedePtsTemplate: '',
				composeSizeId: ''
			},
			addRoleDialog: false,
			tableData: [{}],
			addRoleVo: {},
			role: [],
			sizeList: [],
			tipTableData: [],
			tipDialog: false
		}
	},
	watch: {
		'searchVo.isAssociatedePtsTemplate': {
			handler (val) {
				if (!val) {
					this.searchVo.composeSizeId = ''
					this.searchVo.attrId = ''
				}
			},
			deep: true,
			immediate: false
		}
	},
	created () {
		this.onSubmit()
		this.getRole()
		// this.getSizeList()
	},
	methods: {
		getSizeList (val) {
			if (!val) {
				return
			}
			sizeListPaging({
				pageNum: 1,
				pageSize: 100,
				data: {
					sizeName: val
				}
			}).then(res => {
				if (res.data.success) {
					this.sizeList = res.data.data.records
				}
			})
		},
		getRole () {
			adminModuleAttributeList().then(res => {
				if (res.data.success) {
					this.role = res.data.data
				}
			})
		},
		changePage (val) {
			this.queryInfo = val
			this.onSubmit()
		},
		del (moduleId) {
			getTemplateByModuleId(moduleId).then(res => {
				console.log(res)
				if (res.data.data.exist) {
					// 被模板关联过，弹窗显示信息
					this.tipDialog = true
					this.tipTableData = res.data.data.templates
				} else {
					// 未被模板关联过,弹窗确认删除
					this.deleteModuleDialog = true
				}
			})
		},
		deleteModule () {
			moduleDel(this.deleteItem.moduleId).then(res => {
				if (res.data.success) {
					this.$message.success('删除成功')
					this.onSubmit()
					this.deleteModuleDialog = false
				}
			})
		},
		// 获取尺寸组详细信息
		getSizeGroupMsg (id) {
			sizeDetail(id).then(res => {
				if (res.data.success) {
					this.pageName = res.data.data.pageName
					this.sizeName = res.data.data.sizeName
					this.sizeGroupMsg = res.data.data.barCodeList
					this.bleed = res.data.data.bleed
				}
			})
		},
		onSubmit () {
			modulePage({
				params: { page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize },
				vo: this.searchVo
			}).then(res => {
				if (res.data.success) {
					let list = res.data.data.content
					list.forEach(module => {
						let str = ''
						module.moduleInfoXrefs.forEach(info => {
							if (info.infoType === 'TEXT') {
								str += info.refInfo.name + '：文本长度' + info.infoValue + ' ; '
							} else if (info.infoType === 'IMAGE') {
								str += info.refInfo.name + '：照片数量' + info.infoValue + ' ; '
							}
						})
						module.infoStr = str
					})
					this.tableData = list
					this.queryInfo.total = res.data.data.total
				}
			})
		}
	}
}
</script>
<style lang="less" scoped>
.right-main {
	padding: 10px;
}

.add-category {
	justify-content: space-between;
}

.keywords {
	display: flex;
	justify-content: space-around;
	// width: 750px;
	align-items: center;

	.el-input {
		width: 180px;
	}
}
</style>
